import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKAlert from "components/MKAlert";
import MKButton from "components/MKButton";
import MKInput from "components/MKInput";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Routes
import routes from "routes";

// api
import { checkTargetHc } from "api/master";
import { checkDupHcOa, addRegister, exportCidToDebtTracking } from "api/register";
import { encryptGCM } from "api/crypto";

//util
import { readTextFileToArray } from "utils/readText";

function CallCenterImportRegister() {
  const navigate = useNavigate();
  const location = useLocation();
  const props = location.state;

  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [dataList, setDataList] = useState([]);
  const [regSuccess, setRegSuccess] = useState([]);
  const [regFailded, setRegFailed] = useState([]);
  const [zupdgFailded, setZupdgFailed] = useState([]);
  const inputFileRef = useRef(null);

  useEffect(() => {
    if (props === null) {
      navigate("/ndrs-gsb-register/sign-in");
    }
  }, [regSuccess, regFailded, zupdgFailded]);
  const handleImportData = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    var reigsterSuccessList = [];
    var registerFailedList = "";
    var zupdgFailedList = "";

    console.log("START FOR ADD REGISTER.");
    for (let i = 0; i < dataList.length; i++) {
      console.log("CID : " + dataList[i].CID);
      const citizenIdEncrypted = await encryptGCM({ value: dataList[i].CITIZEN_ID });
      const nameEncrypted = await encryptGCM({ value: dataList[i].NAME });
      const surnameEncrypted = await encryptGCM({ value: dataList[i].SURNAME });
      const telNoEncrypted = await encryptGCM({ value: dataList[i].TELNO });

      console.log("1-Check Check Dupplicate");
      const payloadCheckDup = {
        citizenId: citizenIdEncrypted.encrypted,
        accountNo: dataList[i].CID,
      };
      const resCheckDup = await checkDupHcOa(payloadCheckDup);
      if (resCheckDup.status_flag && resCheckDup.count.check_dup <= 0) {
        console.log("2-Check Target");
        const payloadCheckCustTarget = {
          citizenId: citizenIdEncrypted.encrypted,
          accountNo: dataList[i].CID,
        };
        const resCheckCustTarget = await checkTargetHc(payloadCheckCustTarget);
        if (resCheckCustTarget.status_flag) {
          console.log("3-Insert Register");
          let payloadAddRegister = {
            citizenId: citizenIdEncrypted.encrypted,
            laserCardId: "-",
            cifNo: resCheckCustTarget.data_list[0].cif_no,
            accountNo: resCheckCustTarget.data_list[0].account_no,
            name: nameEncrypted.encrypted,
            surname: surnameEncrypted.encrypted,
            dateOfBirth: "-",
            telNo: telNoEncrypted.encrypted,
            homeNo: "-",
            road: "-",
            subDistrict: "-",
            district: "-",
            province: "-",
            postCode: "-",
            isCustTarget: true,
            debtRepaymentCode: resCheckCustTarget.data_list[0].debt_repayment_code,
          };
          let resAddRegister = await addRegister(payloadAddRegister);
          if (resAddRegister.status_flag) {
            let data = {
              cid: resCheckCustTarget.data_list[0].account_no,
            };
            reigsterSuccessList.push(data);
          } else {
            console.error(resAddRegister.status_message);
            registerFailedList += dataList[i].CID.concat(
              "|บัญชีสินเชื่อนี้ไม่สามารถลงทะเบียนร่วมมาตรการ",
              " \n"
            );
          }
        } else {
          console.error(resCheckCustTarget.status_message);
          registerFailedList += dataList[i].CID.concat(
            "|บัญชีสินเชื่อนี้ไม่ได้รับสิทธิ์เข้าร่วมมาตรการ",
            " \n"
          );
        }
      } else if (resCheckDup.status_flag && resCheckDup.count.check_dup > 0) {
        registerFailedList += dataList[i].CID.concat("|บัญชีสินเชื่อนี้เคยลงทะเบียนแล้ว", " \n");
      } else {
        console.error(resCheckDup.status_message);
        registerFailedList += dataList[i].CID.concat("|", resCheckDup.status_message, " \n");
      }
    }

    console.log("END FOR ADD REGISTER.");
    console.log(reigsterSuccessList);

    if (reigsterSuccessList.length > 0) {
      console.log("START SEND TO ZUPDG.");
      let payload = {
        cidRegList: reigsterSuccessList,
      };
      console.log(payload);
      const res = await exportCidToDebtTracking(payload);
      if (res.status_flag) {
        setIsLoading(false);
        console.log("success => ", res.rsBody.success);
        setIsAlert(true);
        setAlertMsg("ส่งเปลี่ยนลำดับการตัดบัญชีเรียบร้อย");
        setAlertType("success");
        if (res.rsBody.failed.length > 0) {
          for (let i = 0; i < res.rsBody.failed.length; i++) {
            zupdgFailedList += res.rsBody.failed[i].concat(" \n");
          }
        }
      } else {
        setIsLoading(false);
        setIsAlert(true);
        setAlertMsg("ไม่สามารถส่งเปลี่ยนลำดับการตัดบัญชีได้");
        setAlertType("error");
        console.error(res.status_message);
      }
      console.log("END SEND TO ZUPDG.");
    }

    setRegSuccess(reigsterSuccessList);
    setRegFailed(registerFailedList);
    setZupdgFailed(zupdgFailedList);
    setDataList([]);
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
    setIsLoading(false);
    console.log(registerFailedList);
    console.log(zupdgFailedList);
  };

  const handleFileChange = (event) => {
    console.log(event);
    const file = event.target.files[0];
    if (file) {
      // เรียกใช้ฟังก์ชันสำหรับอ่านไฟล์
      readFile(file);
    }
  };

  const readFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      const array = readTextFileToArray(content);
      if (array.length <= 3000) {
        setFileContent(content);
        setDataList(array);
      } else {
        setIsLoading(false);
        setIsAlert(true);
        setAlertMsg("กรุณา upload ครั้งละไม่เกิน 3,000 บัญชี");
        setAlertType("error");
      }
    };
    reader.readAsText(file); // อ่านไฟล์เป็น text
  };
  const handleClearData = (e) => {
    e.preventDefault();
    setIsLoading(false);
    setIsAlert(false);
    setAlertMsg("");
    setAlertType("");
    setFileContent("");
    setDataList([]);
    setRegFailed([]);
    setRegSuccess([]);
    setZupdgFailed([]);
    if (inputFileRef.current) {
      inputFileRef.current.value = "";
    }
  };
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://ln15.gsb.or.th/ndrs",
          label: "GSB NDRS Website",
          color: "default",
        }}
        transparent
        light
      />
      <MKBox
        minHeight="45vh"
        width="100%"
        bgColor="#1e88e5"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h2"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              การลงทะเบียนเข้าร่วมมาตรการผ่อนปรนเงื่อนไขการชำระหนี้
            </MKTypography>
            <MKTypography variant="h5" color="white" opacity={1} mt={1} mb={3}>
              มาตรการให้ความช่วยเหลือลูกหนี้ที่มีสถานะเป็นหนี้เสียที่มีภาระหนี้เงินต้นและดอกเบี้ยไม่เกิน
              1 แสนบาท
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" py={{ xs: 6, sm: 12 }}>
          <Container>
            {isAlert ? (
              <>
                <MKAlert color={alertType} autoHideDuration={15000} dismissible>
                  {alertMsg}
                </MKAlert>
                <br />
              </>
            ) : null}
            <Grid container item xs={12} spacing={5} justifyContent="center" mx="auto">
              <MKTypography
                variant="h5"
                fontWeight="medium"
                color="primary"
                justifyContent="center"
              >
                Import เปลี่ยนลำดับการตัด
              </MKTypography>
            </Grid>
            <Grid container item xs={12} justifyContent="center" py={4}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MKTypography variant="body2" fontWeight="medium" color="dark">
                    เลือกไฟล์ Text สำหรับนำเข้าข้อมูล (.txt)
                  </MKTypography>
                  <MKInput
                    type="file"
                    color="primary"
                    onChange={handleFileChange}
                    inputProps={{
                      accept: ".txt",
                    }}
                    inputRef={inputFileRef}
                    fullWidth
                  />
                  <br />
                  <br />
                  <MKTypography variant="body2" fontWeight="medium" color="dark">
                    ข้อมูลที่เตรียมนำเข้า
                  </MKTypography>
                  {fileContent ? (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      {fileContent}
                    </pre>
                  ) : (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      -
                    </pre>
                  )}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" py={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MKTypography variant="body2" fontWeight="medium" color="error">
                    เลขบัญชีที่ลงทะเบียนไม่สำเร็จ
                  </MKTypography>
                  {regFailded.length > 0 ? (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      {regFailded}
                    </pre>
                  ) : (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      -
                    </pre>
                  )}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" py={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MKTypography variant="body2" fontWeight="medium" color="error">
                    เลขบัญชีที่ส่งเปลี่ยนลำดับการตัดไม่สำเร็จ
                  </MKTypography>
                  {zupdgFailded.length > 0 ? (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      {zupdgFailded}
                    </pre>
                  ) : (
                    <pre style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem" }}>
                      -
                    </pre>
                  )}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" py={2}>
                <MKButton variant="contained" color="success" onClick={handleImportData}>
                  นำเข้าข้อมูล
                </MKButton>
                &nbsp;
                <MKButton variant="contained" color="secondary" onClick={handleClearData}>
                  ล้างข้อมูล
                </MKButton>
                &nbsp;
                <MKButton
                  variant="contained"
                  color="dark"
                  onClick={() => navigate("/ndrs-gsb-register/sign-in")}
                >
                  Logout
                </MKButton>
              </Grid>
              {isLoading ? (
                <Grid container justifyContent="center">
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Stack sx={{ width: "50%" }}>
                      <LinearProgress color="primary" />
                    </Stack>
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Container>
        </MKBox>
      </Card>
    </>
  );
}
CallCenterImportRegister.defaultProps = {
  user: {},
};
CallCenterImportRegister.propTypes = {
  user: PropTypes.shape({
    title: PropTypes.string,
    postalCode: PropTypes.string,
    displayName: PropTypes.string,
    otherPager: PropTypes.string,
    department: PropTypes.string,
    streetAddress: PropTypes.string,
    employeeType: PropTypes.string,
    employeeID: PropTypes.string,
    division: PropTypes.string,
    token: PropTypes.string,
    accessToken: PropTypes.string,
    isLogin: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isCallCenter: PropTypes.bool,
    isIt: PropTypes.bool,
  }),
};

export default CallCenterImportRegister;
